export class UserSetting {

    constructor(key: string, groupKey?: string, value1?: string, value2?: string, value3?: string) {
        this.Key = key;
        this.GroupKey = groupKey;
        this.Value1 = value1;
        this.Value2 = value2;
        this.Value3 = value3;
    }

    public GroupKey: string;
    public Key: string;
    public Value1: string;
    public Value2: string;
    public Value3: string;
}
